export default __webpack_public_path__ + "static/media/icomoon.f38f8660.woff";